var exports = {
  "K": "UserProfileActionsSheet.module__icon___XzhHbT",
};

module.exports = exports;
